import './SetupView.css';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import ProductListing from './ProductListing';

const SetupView = () => {

    const handleChatButtonClick = () => {
        window.location.href = "/contact";
    };
    return (
        <div className='setup-container background-primary'>
            <Container maxWidth='xl' disableGutters>
                <div className='setup-platform background-primary'>
                    <h3 className='setup-pre-title'>Get Started</h3>
                    <h1 className='setup-title text-title'>Dead-Simple Setup</h1>
                    <h2 className='setup-subtitle text-description'>
                        <b>Blankwall</b> automagically generates AR experience from your product image,
                        no&nbsp;lengthy&nbsp;setup.<br/>
                        Add the <b>Blankwall</b> button to your product page 
                        and your entire catalog is supported. 
                    </h2>
                </div>

                <ProductListing />
                <div style={{padding: '2rem'}}></div>

                {/* Two platforms to choose from */}
                <Grid container className='setup-platform background-secondary' >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: 'auto' }}>
                        <h1 className='setup-step-number text-title foreground-highlight'>01</h1>
                        <h1 className='setup-step-title text-heading'>
                            Add the Blankwall button to your product page
                        </h1>
                    </div>
                    <Grid item xs={12} md={8} sx={{ paddingRight: { xs: 0, md: '3rem' } }}>
                        <img className='setup-img' src='step-1.png' alt='platform-shopify'/>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ alignSelf: 'center' }}>
                        <h2 className='setup-platform-heading text-subheading'>
                            Install <b>Blankwall</b> from the Shopify App store
                        </h2>
                        <ul className='text-description' style={{paddingInlineStart: '18px'}}>
                            <li>Find us on Shopify App Store</li>
                            <li>Add Blankwall button to your theme</li>
                            <li>Done!</li>
                        </ul>
                        <a href="https://apps.shopify.com/blankwall" style={{ width: '160px', margin: '0' }} >
                            <img className='setup-shopify-button' src='Shopify-App-Store-Badge-Final-Black.svg' alt='find-on-shopify' />
                        </a>
                    </Grid>

                    {/* Divider Line */}
                    <Grid item xs={12} textAlign='center'>
                        <hr style={{ width: '100%', borderTop: '2px solid black', margin: '5rem 0' }} />
                    </Grid>

                    <Grid item xs={12} md={4} sx={{ order: { xs: 2, md: 1 }, alignSelf: 'center' }}>
                        <h2 className='setup-platform-heading text-subheading'>
                            Integrate with <b>Blankwall</b>&nbsp;widget
                        </h2>
                        <h2 className='text-description'>Whether your store is on Squarespace, Wordpress or custom built - <b>we have a solution for you!</b></h2>
                        <button style={{ width: '160px', margin: '0' }} className="hero-button hero-button-secondary" onClick={handleChatButtonClick}>
                            Let's Chat
                        </button>
                    </Grid>
                    <Grid item xs={12} md={8} sx={{ alignSelf: 'center', paddingLeft: { xs: 0, md: '3rem' }, order: { xs: 1, md: 2 } }}>
                        {/* <ul style={{ display: 'flex', flexDirection:'column', listStyleType: 'none', justifyContent: 'center', alignItems: 'center', margin: '0', padding:'0' }}>
                        </ul> */}
                        <img className='setup-img' src='setup-demo.gif' alt='setup-demo'/>
                    </Grid>
                    <Grid item width='100%' sx={{order: { xs: 3, md: 3 }, paddingTop: '2rem'}}>
                        <ul style={{ margin:'0', display: 'flex', listStyleType: 'none', justifyContent: 'center', alignItems: 'center', gap: '1rem', padding: '0'}}>
                            <li>
                                <img style={{ maxWidth: '250px', width: '100%'}} src='squarespace-logo-black.png' alt='squarespace-logo' />
                            </li>
                            <li>
                                <img style={{ maxWidth: '100px', width: '100%'}} src='html5-logo-black.svg' alt='custom-built-logo' />
                            </li>
                            <li>
                                <img style={{ maxWidth: '250px', width: '100%'}} src='wordpress-logo-standard.png' alt='wordpress-logo' />
                            </li>
                        </ul>
                    </Grid>
                </Grid>
                {/* Automagically */}
                <Grid container className='setup-magic background-primary'>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: 'auto' }}>
                        <h1 className='setup-step-number text-title foreground-highlight'>02</h1>
                        <h1 className='setup-step-title text-heading'>
                            Your entire catalog is automagically supported
                        </h1>
                    </div>
                    <Grid item xs={12} md={8} sx={{ paddingRight: { xs: 0, md: '3rem' }, alignItems: 'center', display:"flex"}}>
                        <img className='setup-img' style={{ width: 'auto', maxWidth: '100%'}} src='automagically-nobtn.png' alt='automagically' />
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ alignSelf: 'center', paddingLeft: { xs: 0, md: '2rem'}}}>
                        <h2 className='setup-magic-desc text-description'>
                            No manual per-product setup.
                        </h2>
                        <h2 className='setup-magic-desc text-description'>
                            No additional work when new products are added.
                        </h2>
                        <h2 className='setup-magic-desc text-description'>
                            <b>Ready to onboard?</b>
                        </h2>
                        <button style={{ width: '160px', margin: '0' }} className="hero-button hero-button-secondary" onClick={handleChatButtonClick}>
                            Let's Chat
                        </button>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default SetupView;